<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        color="success"
        v-on="on"
        v-bind="attrs"
        block
        class="subtitle-1"
        >Salvar dados</v-btn
      >
    </template>
    <v-card>
      <v-card-title>Salvar dados</v-card-title>
      <v-card-text class="subtitle-1">
        {{
          editar
            ? `Confirma a alteração dos dados do cliente ${clienteManut.nome} ??`
            : `Confirma a inclusão do cliente ${clienteManut.nome} ??`
        }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          rounded
          color="success"
          @click="salvarCliente()"
          :loading="salvando"
          >Sim, confirmar</v-btn
        >
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("clientes", ["clienteManut", "editar"]),
    ...mapState("locais", ["municSelec", "localidSelec"]),
  },
  data: () => ({
    dialog: false,
    salvando: false,
  }),
  methods: {
    async salvarCliente() {
      this.salvando = true;

      this.clienteManut.nroend = parseInt(this.clienteManut.nroend);
      this.clienteManut.dddcelular = parseInt(this.clienteManut.dddcelular);
      this.clienteManut.codmunicipio = this.municSelec;
      this.clienteManut.codlocalidade = this.localidSelec;
      this.clienteManut.areapropria = parseFloat(this.clienteManut.areapropria);
      this.clienteManut.areaarrendada = parseFloat(
        this.clienteManut.areaarrendada
      );

      await axios
        .post(
          "/nutricao-animal/clientes/salvar-cliente",
          JSON.stringify(this.clienteManut)
        )
        .then((res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg, {
              duration: 3000,
            });
            this.$router.go(-1);
          } else {
            this.$toasted.error(res.data.msg);
            this.dialog = false;
          }
        })
        .catch((e) => this.$toasted.error(e));
      this.salvando = false;
    },
  },
};
</script>

<style>
</style>